module.exports = __webpack_public_path__ + "img/rgb.b85bb99b.png";